export default __webpack_public_path__ + "static/media/sellPriceUpload.f6d54d20.xlsx";